<template>
  <b-modal
    ref="email"
    id="email-modal"
    @ok="sendEmail"
    size="lg"
    title="Envío de notificación"
  >

    <b-form-group>
      <label for="name">Para</label>
      <b-form-input
        type="text"
        v-model="to"
        ></b-form-input>
    </b-form-group>

    <b-form-group>
      <label for="name">CC</label>
      <b-form-input
        type="text"
        v-model="cc"
         ></b-form-input>
    </b-form-group>

    <b-form-group>
      <label for="name">CCO</label>
      <b-form-input
        type="text"
        v-model="bcc"
         ></b-form-input>
    </b-form-group>

    <b-form-group>
      <label for="name">Asunto</label>
      <b-form-input
        type="text"
         
        v-model="subject"></b-form-input>
    </b-form-group>

    <b-form-group>
      <label for="name">Mensaje</label>
      <b-form-textarea
        id="textarea"
        v-model="msg"
        placeholder="Enter something..."
        rows="3"
        max-rows="6"
      ></b-form-textarea>
    </b-form-group>

  </b-modal>
</template>

<script>

  import Vue from 'vue'
  import Multiselect from 'vue-multiselect'

  import miniToastr from 'mini-toastr'

  const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})
Vue.use(miniToastr);

  export default {
    name: "emailModal",
    components: {
      Multiselect
    },
    props: ['to', 'cc', 'bcc', 'msg', 'subject','waybill_id','process_id','type','process_type_option'],
    methods: {
      sendEmail () {

        if(this.type==1){

          this.$axios({
          method: 'post',
          url: '/reports/send_arrival_pdf/'+this.waybill_id,
          params: {
            to: this.to,
            cc: this.cc,
            bcc: this.bcc,
            subject: this.subject,
            msg: this.msg,
          }
        })
          .then(res => {
          })
          .catch(error => {
            console.log(error)
          });

        }



        if(this.type==2)
        {


              this.$axios({
              method: 'post',
              url: '/reports/send_process_pdf/'+this.process_id+'/'+this.process_type_option,
              params: {
                to: this.to,
                cc: this.cc,
                bcc: this.bcc,
                subject: this.subject,
                msg: this.msg,
              }
            })
            .then(res => {
            })
            .catch(error => {
              console.log(error)
            });



        }



       
      }
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>
<style>
  .form-control .multislelect__input{

  }
  .multislelect__tags{
        font-size: 11px;
  }
</style>
